/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputPilotData } from './OutputPilotData';
import {
    OutputPilotDataFromJSON,
    OutputPilotDataFromJSONTyped,
    OutputPilotDataToJSON,
} from './OutputPilotData';

/**
 * 
 * @export
 * @interface OutputSessionData
 */
export interface OutputSessionData {
    /**
     * 
     * @type {boolean}
     * @memberof OutputSessionData
     */
    allowBomberMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputSessionData
     */
    allowOpticMissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputSessionData
     */
    allowRadioMissions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputSessionData
     */
    craftName: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSessionData
     */
    droneUid: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSessionData
     */
    freqRange: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputSessionData
     */
    hasVideoLinks?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputSessionData
     */
    id: number;
    /**
     * 
     * @type {Array<OutputPilotData>}
     * @memberof OutputSessionData
     */
    pilots: Array<OutputPilotData>;
    /**
     * 
     * @type {number}
     * @memberof OutputSessionData
     */
    positionId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputSessionData
     */
    preferredChannels: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OutputSessionData
     */
    team: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof OutputSessionData
     */
    zones: { [key: string]: string; };
}

/**
 * Check if a given object implements the OutputSessionData interface.
 */
export function instanceOfOutputSessionData(value: object): boolean {
    if (!('craftName' in value)) return false;
    if (!('droneUid' in value)) return false;
    if (!('freqRange' in value)) return false;
    if (!('id' in value)) return false;
    if (!('pilots' in value)) return false;
    if (!('preferredChannels' in value)) return false;
    if (!('team' in value)) return false;
    if (!('zones' in value)) return false;
    return true;
}

export function OutputSessionDataFromJSON(json: any): OutputSessionData {
    return OutputSessionDataFromJSONTyped(json, false);
}

export function OutputSessionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSessionData {
    if (json == null) {
        return json;
    }
    return {
        
        'allowBomberMissions': json['allowBomberMissions'] == null ? undefined : json['allowBomberMissions'],
        'allowOpticMissions': json['allowOpticMissions'] == null ? undefined : json['allowOpticMissions'],
        'allowRadioMissions': json['allowRadioMissions'] == null ? undefined : json['allowRadioMissions'],
        'craftName': json['craftName'],
        'droneUid': json['droneUid'],
        'freqRange': json['freqRange'],
        'hasVideoLinks': json['hasVideoLinks'] == null ? undefined : json['hasVideoLinks'],
        'id': json['id'],
        'pilots': ((json['pilots'] as Array<any>).map(OutputPilotDataFromJSON)),
        'positionId': json['positionId'] == null ? undefined : json['positionId'],
        'preferredChannels': json['preferredChannels'],
        'team': json['team'],
        'zones': json['zones'],
    };
}

export function OutputSessionDataToJSON(value?: OutputSessionData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allowBomberMissions': value['allowBomberMissions'],
        'allowOpticMissions': value['allowOpticMissions'],
        'allowRadioMissions': value['allowRadioMissions'],
        'craftName': value['craftName'],
        'droneUid': value['droneUid'],
        'freqRange': value['freqRange'],
        'hasVideoLinks': value['hasVideoLinks'],
        'id': value['id'],
        'pilots': ((value['pilots'] as Array<any>).map(OutputPilotDataToJSON)),
        'positionId': value['positionId'],
        'preferredChannels': value['preferredChannels'],
        'team': value['team'],
        'zones': value['zones'],
    };
}

